<template>
  <tr>
    <td class="text-center text-middle middle">
      {{ index + 1 }}.
    </td>

    <w-table-cell :model="item.employerName">
      <w-input title-attribute="Nazwa pracodawcy" :model="item.employerName" />
    </w-table-cell>

    <w-table-cell :model="item.otherWorkStart">
      <w-datepicker
        title-attribute="Rozpoczęcie pracy u poprzedniego pracodawcy"
        :model="item.otherWorkStart"
      />
    </w-table-cell>

    <w-table-cell :model="item.otherWorkEnd">
      <w-datepicker
        title-attribute="Zakończenie pracy u poprzedniego pracodawcy"
        :model="item.otherWorkEnd"
      />
    </w-table-cell>

    <td class="text-center">
      <w-row-buttons
        :model="item"
        :move-up="index != 0"
        :move-down="item.$parent.$value.length - 1 !== index"
      />
    </td>
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';

// @vuese
// Pojedynczy wiersz tabeli nauczuciele
// @Group detailsComponents
export default {
  components,
  props: {
    // Wartość przekazana do wypelnienia pola w schemacie
    item: { type: Object, required: true },

    // Indeks
    index: { type: Number, required: true }
  }
};
</script>
